export default __webpack_public_path__ + "static/media/producer_screen_img.4f1488f9.png";